import React from "react";
import { Link } from "react-router-dom";
import logo from "../../../assets/logo.png";

const Footer = () => {
  return (
    <div>
      {/* Footer */}
      <footer className="bg-gradient-to-b from-gray-800 to-gray-900 text-white py-12 px-4">
        <div className="container mx-auto max-w-6xl">
          <div className="grid md:grid-cols-5 gap-8">
            {/* Brand Section */}
            <div className="md:col-span-2">
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-r from-orange-500 to-red-500 rounded-full p-0.5">
                  <div className="w-full h-full rounded-full overflow-hidden">
                    <img
                      src={logo}
                      alt="MahalaxmiPuja Logo"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
                <h3 className="text-xl font-bold">MahalaxmiPuja</h3>
              </div>
              <p className="text-gray-400 mb-4 leading-relaxed">
                Dedicated to Shree Mahalaxmi Ambabai of Kolhapur. Bringing
                authentic temple blessings and traditional puja services to
                devotees worldwide.
              </p>
              <div className="flex space-x-4">
                {["Facebook", "Instagram", "YouTube", "Twitter"].map(
                  (social, index) => (
                    <button
                      key={social}
                      className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gradient-to-r hover:from-orange-500 hover:to-red-500 transition-all transform hover:scale-110"
                    >
                      {social[0]}
                    </button>
                  )
                )}
              </div>
            </div>

            {/* Quick Links */}
            {[
              {
                title: "Puja Services",
                links: [
                  { name: "KULACHAR", path: "/services" },
                  { name: "PANCHAMRUT ABHISHEK", path: "/services" },
                  { name: "SAREE OTEE", path: "/services" },
                  { name: "KUMKUMARCHAN", path: "/services" },
                  { name: "PADYA PUJA", path: "/services" },
                ],
              },
              {
                title: "Support",
                links: [
                  { name: "Help Center", path: "/contact" },
                  { name: "Contact Us", path: "/contact" },
                  { name: "Email Support", path: "/contact" },
                  { name: "Puja Guidance", path: "/contact" },
                  { name: "FAQ", path: "/contact" },
                ],
              },
              {
                title: "About Temple",
                links: [
                  { name: "Temple History", path: "/temple" },
                  { name: "Mahalaxmi Ambabai", path: "/temple" },
                  { name: "Kolhapur Heritage", path: "/temple" },
                  { name: "Darshan Timings", path: "/temple" },
                  { name: "Festivals", path: "/temple" },
                ],
              },
            ].map((section, index) => (
              <div key={index}>
                <h4 className="font-semibold mb-4 text-orange-400">
                  {section.title}
                </h4>
                <ul className="space-y-2">
                  {section.links.map((link, linkIndex) => (
                    <li key={linkIndex}>
                      <Link
                        to={link.path}
                        className="text-gray-400 hover:text-white transition-colors hover:underline"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Bottom Footer */}
          <div className="border-t border-gray-800 mt-8 pt-8">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 text-sm">
                © 2026 MahalaxmiPuja.com. All rights reserved. Blessed by Shree
                Mahalaxmi Ambabai, Kolhapur 🪔
              </p>
              <div className="flex space-x-6 mt-4 md:mt-0">
                <Link
                  to="/terms-conditions"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  Terms
                </Link>
                <Link
                  to="/privacy-policy"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  Privacy
                </Link>
                <Link
                  to="/refund-policy"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  Refund Policy
                </Link>
                <Link
                  to="/temple"
                  className="text-gray-400 hover:text-white text-sm transition-colors"
                >
                  About Temple
                </Link>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
